/* eslint-disable no-nested-ternary */
import React, { type ReactNode, useContext } from 'react'
import Placeholder from '../../../Atoms/Placeholder'
import Typography from '../../../Atoms/Typography'
import { CardContext } from '..'

interface ITitleProps {
  children: ReactNode
  as?: React.ElementType
}

export const Title = (props: ITitleProps) => {
  const { children, as = 'h3' } = props
  const { matches, variant } = useContext(CardContext)

  const typographyProps = matches.large ? { variant: 'title', size: 'xs' } as const: // prettier-ignore
                  matches.medium ? { variant: 'title', size: 'xs' } as const :       // prettier-ignore
                  matches.small ? { variant: 'body', size: 'l' } as const :          // prettier-ignore
                  { variant: 'body', size: 'l' } as const // prettier-ignore

  const linesToClamp = variant === 'lite' ? 2 : 3

  return (
    <Typography
      as={as}
      data-testid="property-card-title"
      {...typographyProps}
      clamp={linesToClamp}
      bold
      color="var(--color-neutral-900)"
    >
      {children}
    </Typography>
  )
}

Title.displayName = 'Card.Title'

function TitlePlaceholder() {
  return <Placeholder.Text lines={1} lineHeight="27px" width="100%" />
}
TitlePlaceholder.displayName = 'Card.Title.Placeholder'

Title.Placeholder = TitlePlaceholder
